import {
    HTTP
} from '../http-common'

export default {
    state: {
        repairStagesList : [],
        totalRepairStages : 0,
        itemsRepairTypes : [],
        itemsServiceStatus: [],
        itemsRepairCardStatus: [],
        itemsManagers: [],
        itemsContractors: [],
        itemsStagesTypes: [],
        i: {}
    },
    mutations: {
        setRepairStagesList (state, payload) {
            state.repairStagesList = payload  
        },
        setTotalRepairStages (state, payload){
            state.totalRepairStages = payload
        },
        itemsRepairTypes(state, payload) {
            state.itemsRepairTypes = payload
        },
        itemsServiceStatus(state, payload) {
            state.itemsServiceStatus = payload
        },
        itemsRepairCardStatus(state, payload) {
            state.itemsRepairCardStatus = payload
        },
        itemsManagers(state, payload) {
            state.itemsManagers = payload
        },
        itemsContractors(state, payload) {
            state.itemsContractors = payload
        },
        itemsStagesTypes(state,  payload){
            state.itemsStagesTypes = payload
        },
        i(state,  payload){
            state.i = payload
        },
    },
    actions: {
        getRepairStagesList({commit}, params){
            return new Promise ((resolve, reject) => {
                HTTP.get(`repair_card/stages_list`, {
                    params:  {
                        ...params,
                    }
                })
                .then(response => {
                    if (response.data) {
                        commit('setRepairStagesList', response.data.data)
                        commit('setTotalRepairStages', Number(response.data.total))
                        resolve(response.data)
                    }
                    else {
                        reject(response.data.error)
                    }
                })
                .catch(e => {
                    reject(e)
                })
            })
        },
        get({commit, state}, p) {
            HTTP.get(p.url, {params: p.params})
            .then(response => {
                if (response.status == 200 && response.data && response.data.data) {
                    commit(p.model, response.data.data)
                }
            })
            .catch(e => {
                console.log(p, e)
            })
        }
    },
    getters: {
        lastRepairStage(state) {
            return state.repairStagesList[state.repairStagesList.length - 1] || {}
        },
        totalRepairStages(state) {
            return state.totalRepairStages
        },
        itemsRepairTypes(state) {
            return state.itemsRepairTypes
        },
        itemsServiceStatus(state) {
            return state.itemsServiceStatus
        },
        itemsRepairCardStatus(state) {
            return state.itemsRepairCardStatus
        },
        itemsManagers(state) {
            return state.itemsManagers
        },
        itemsContractors(state) {
            return state.itemsContractors
        },
        itemsStagesTypes(state){
            return state.itemsStagesTypes
        },
        i(state){
            return state.i
        }
    }
}